export default class Gate{

    constructor(user){
        this.user = user;
    }

    isAdmin(){
        return this.user.type === 'admin';
    }

    isOpd(){
        return this.user.type === 'opd';
    }

    isStafUptd(){
        return this.user.type === 'stafuptd';
    }

    isStafAdminOpd(){
        return this.user.type === 'stafadminopd';
    }

    isStafRuang(){
        return this.user.type === 'stafruang';
    }
    
    isAdmin1(){
        if(this.user.type === 'opd' || this.user.type === 'admin'){
            return true;
        }
    }

    isAdmin2(){
        if(this.user.type === 'stafuptd' || this.user.type === 'opd' || this.user.type === 'admin'){
            return true;
        }
    }
}

